import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, fmtErr } from "@/lib/api";
import { AuthShell, Field } from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function RegisterPage() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      nav("/");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell kicker="Reader account" title="Join the conversation">
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <Field label="Full name"><Input data-testid="register-name-input" required value={form.name} onChange={set("name")} className="rounded-none h-11 bg-white" /></Field>
        <Field label="Email"><Input data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} className="rounded-none h-11 bg-white" /></Field>
        <Field label="Password" hint="At least 8 characters, with letters and numbers"><Input data-testid="register-password-input" type="password" required minLength={8} value={form.password} onChange={set("password")} className="rounded-none h-11 bg-white" /></Field>
        {error && <p data-testid="register-error" className="text-sm text-[#DC2626] border-l-2 border-[#DC2626] pl-3">{error}</p>}
        <Button data-testid="register-submit-btn" disabled={busy} className="w-full h-11 rounded-none font-bold">Create account</Button>
      </form>
      <p className="mt-8 text-sm">Already registered? <Link to="/login" className="font-bold underline">Sign in</Link></p>
    </AuthShell>
  );
}
